/** 限制只能输入手机号 */
export const PHONE_REG = /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/

/** 收费标准正则 0.01 ~ 2.99 */ 
export const feeReg = /^([1-2]|0\.(0[1-9]|[1-9][0-9]?)|[1-2]\.\d{1,2}|2\.([0-8][0-9]|9[0-9]))$/